// `bg`/`text`/`dot` style PostMailingStatusBadge; `tone` maps the status onto the global Tag.
export const CAMPAIGN_STATUS_CONFIG = {
	draft: { label: 'Entwurf', tone: 'neutral', bg: 'bg-bgBase-400', text: 'text-text' },
	awaiting_payment: {
		label: 'Warten auf Zahlung',
		tone: 'caution',
		bg: 'bg-caution-200',
		text: 'text-caution-700',
		animate: true,
		dot: 'bg-caution-500',
	},
	payment_processing: {
		label: 'Zahlung wird verarbeitet',
		tone: 'primary',
		bg: 'bg-primary-200',
		text: 'text-primary-700',
		animate: true,
		dot: 'bg-primary-500',
	},
	sending: {
		label: 'Wird versendet',
		tone: 'primary',
		bg: 'bg-primary-200',
		text: 'text-primary-700',
		animate: true,
		dot: 'bg-primary-500',
	},
	needs_review: { label: 'Prüfung erforderlich', tone: 'caution', bg: 'bg-caution-200', text: 'text-caution-700' },
	awaiting_offer: { label: 'Angebot angefragt', tone: 'caution', bg: 'bg-caution-200', text: 'text-caution-700' },
	ready_to_distribute: {
		label: 'Bereit zum Versand',
		tone: 'primary',
		bg: 'bg-primary-200',
		text: 'text-primary-700',
	},
	completed: { label: 'Abgeschlossen', tone: 'success', bg: 'bg-success-200', text: 'text-success-700' },
	failed: { label: 'Fehlgeschlagen', tone: 'warning', bg: 'bg-warning-200', text: 'text-warning-700' },
	partially_failed: {
		label: 'Teilweise fehlgeschlagen',
		tone: 'warning',
		bg: 'bg-warning-200',
		text: 'text-warning-700',
	},
	cancelled: { label: 'Storniert', tone: 'neutral', bg: 'bg-bgBase-400', text: 'text-bgBase-800' },
};

export const getCampaignStatusTag = (status) => {
	const { label, tone } = CAMPAIGN_STATUS_CONFIG[status] || CAMPAIGN_STATUS_CONFIG.draft;
	return { prefix: 'Status', label, tone };
};
